export const themes = () => ({
  mobile: {
    thWrapper: 'flex flex-col',
    thDashSeparator: 'mx-10',
    thTransportWrapper: 'block mb-5',
    thCompanyLogo: 'my-10',
    thManyCompanies: 'w-1/2 py-10',
    thOperator: 'block',
    thOperatorInfoButton: 'h-20 top-[5px]',
    thItinerary: 'w-3/10',
    thTransportInfos: 'block',
    thLuggage: 'hidden',
  },
  desktop: {
    thWrapper: 'flex flex-row',
    thDashSeparator: 'my-10',
    thTransportWrapper: 'flex items-center justify-stretch mb-5',
    thCompanyLogo: 'w-1/5',
    thManyCompanies: 'w-full py-15',
    thOperator: 'flex items-center',
    thOperatorInfoButton: 'h-20',
    thItinerary: 'w-1/5',
    thTransportInfos: 'flex',
    thLuggage: 'inline-block',
  },
});
